/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 1:15 PM
 *
 */

import React, { PropsWithChildren } from 'react';
import { HouseSimple, Question, UserList } from 'phosphor-react';

import { orgAdminWelcomeSlides, WelcomeModal } from 'features/dashboard/components/WelcomeModal';
import { ROUTES } from 'routes/routes';

export type RouteObjectType =
  | {
      id: number | string;
      title: string;
      icon: React.ReactNode;
      link?: string | false;
      children?: never;
      modal?: React.FC<PropsWithChildren<{ children: React.ReactNode }>>;
    }
  | {
      id: number | string;
      title: string;
      icon: React.ReactNode;
      link?: never;
      children?: RouteObjectType[];
    };

export const schoolAdminNavRoutes: RouteObjectType[] = [
  {
    id: 1,
    title: 'Dashboard',
    icon: <HouseSimple size={24} />,
    link: ROUTES.DASHBOARD,
  },
  {
    id: 21,
    title: 'Members',
    icon: <UserList size={24} />,
    link: ROUTES.MEMBERS,
  },
  {
    id: 3,
    title: 'How To Use',
    icon: <Question size={24} />,
    link: false,
    modal: ({ children }) => (
      <WelcomeModal images={orgAdminWelcomeSlides}> {children}</WelcomeModal>
    ),
  },
];
